import { WHITEBOARD_URL } from "../../config";
import { YOUTUBE_API_KEY } from "../env.config";
export default {
  qrcode: WHITEBOARD_URL,
  flow_id: "7fc572df-98ba-429c-9963-5e65faed02d9",
  class_id: "EPVJ9D",
  endpointURL: WHITEBOARD_URL,
  userName: "sooraj",
  userID: "12345",
  className: "science",
  width: 1280,
  height: 720,
  flowItemURL: `${WHITEBOARD_URL}einsclass/flowItem/`,
  uploadURL: `${WHITEBOARD_URL}einsclass/uploaded/`,
  getImagesURL: "https://academy.einsos.com/search/getResults",
  uploadBackgroundImage: `${WHITEBOARD_URL}einsclass/uploadBackground`,
  getVideosURL: `https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=20&order=viewCount&safeSearch=strict&type=video&videoCategoryId=27&videoEmbeddable=true&key=${YOUTUBE_API_KEY}&q=`,
  getWebPageURL: (title) =>
    `https://en.wikipedia.org/w/api.php?format=json&action=query&prop=extracts&redirects=true&origin=*&titles=${title}`,
};

// export default {
//   qrcode: "http://localhost:8073/",
//   flow_id: "7fc572df-98ba-429c-9963-5e65faed02d9",
//   class_id: "EPVJ9D",
//   endpointURL: "http://localhost:8073/",
//   userName: "sooraj",
//   userID: "12345",
//   className: "science",
//   width: 1280,
//   height: 720,
//   flowItemURL: "http://localhost:8073/einsclass/flowItem/",
//   uploadURL: "http://localhost:8073/einsclass/uploaded/",
//   getImagesURL: "https://academy.einsos.com/search/getResults",
//   getVideosURL:
//     "https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=20&order=viewCount&safeSearch=strict&type=video&videoCategoryId=27&videoEmbeddable=true&key=AIzaSyCjx2_rs5n5bZWcom9Oa2rGwVWpd-I2hno&q=",
//   getWebPageURL: title =>
//     `https://en.wikipedia.org/w/api.php?format=json&action=query&prop=extracts&redirects=true&origin=*&titles=${title}`
// };

// export default {
//   'flow_id': "3bfbdf35-75e5-4bd0-8a58-d530e4369098",
//   'class_id': "QFWDA3",
//   'endpointURL': "http://172.16.2.112:8051/",
//   'userName': "sooraj",
//   'userID': "12345",
//   'className': "science",
//   'flowItemURL': "http://172.16.2.112:8051/einsclass/flowItem/",
//   'uploadURL': "http://172.16.2.112:8051/einsclass/uploaded/",
//   'getImagesURL': "https://academy.einsos.com/search/getResults",
//   'getVideosURL': "https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=20&order=viewCount&safeSearch=strict&type=video&videoCategoryId=27&videoEmbeddable=true&key=AIzaSyCjx2_rs5n5bZWcom9Oa2rGwVWpd-I2hno&q=",
// };

// export default {
//   'flow_id': "3bfbdf35-75e5-4bd0-8a58-d530e4369098",
//   'class_id': "QFWDA3",
//   'endpointURL': "http://172.16.2.112:8051/",
//   'userName': "sooraj",
//   'userID': "12345",
//   'className': "science",
//   'flowItemURL': "http://172.16.2.112:8051/einsclass/flowItem/",
//   'uploadURL': "http://172.16.2.112:8051/einsclass/uploaded/",
//   'getImagesURL': "https://academy.einsos.com/search/getResults",
//   'getVideosURL': "https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=20&order=viewCount&safeSearch=strict&type=video&videoCategoryId=27&videoEmbeddable=true&key=AIzaSyCjx2_rs5n5bZWcom9Oa2rGwVWpd-I2hno&q=",
// };
